import { useState, type FormEvent } from "react";
import { useOnboardingForm } from "../useOnboardingForm";
import { StepShell, StepHeading, RadioCard } from "@codel/dova-ds";
import { Button } from "../components/Button";
import type { StepProps } from "../flowConfig";
import type { RelationshipLength } from "../../types";
// Options live in `answerVocabulary.ts` — see the note there on why a label may
// not be reworded in place once its key has shipped.
import { RELATIONSHIP_LENGTH_OPTIONS as LENGTH_OPTIONS } from "../answerVocabulary";

export function S4bLength({ onNext, onBack, currentStepIndex, totalSteps }: StepProps) {
  const { state, updateAnswers } = useOnboardingForm();
  const [length, setLength] = useState<RelationshipLength | null>(state.answers.relationshipLength);
  const [error, setError] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!length) {
      setError("Pick one to continue.");
      return;
    }
    setError("");
    updateAnswers({ relationshipLength: length });
    onNext();
  };

  return (
    <StepShell
      showBack
      onBack={onBack}
      currentStep={currentStepIndex}
      totalSteps={totalSteps}
      onSubmit={handleSubmit}
      footer={<Button type="submit">Continue</Button>}
    >
      <StepHeading title="How long have you been together?" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          {LENGTH_OPTIONS.map((opt) => (
            <RadioCard
              key={opt.value}
              name="relationship_length"
              value={opt.value}
              label={opt.label}
              checked={length === opt.value}
              onChange={(v) => {
                setLength(v as RelationshipLength);
                if (error) setError("");
              }}
            />
          ))}
        </div>
        {error && (
          <p className="text-xs leading-[1.5] text-[var(--danger)]">{error}</p>
        )}
      </div>
    </StepShell>
  );
}
